var React = require('react');

function ShiftDashes (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"116","height":"16","rx":"8","fill":"#549092","key":0}),React.createElement("path",{"d":"M72 32C72 27.5817 75.5817 24 80 24H180V40H80C75.5817 40 72 36.4183 72 32V32Z","fill":"#FF5670","key":1}),React.createElement("path",{"d":"M180 0H134C129.582 0 126 3.58172 126 8V8C126 12.4183 129.582 16 134 16H180V0Z","fill":"#7200A0","key":2})]);
}

ShiftDashes.defaultProps = {"width":"180","height":"40","viewBox":"0 0 180 40","fill":"none"};

module.exports = ShiftDashes;

ShiftDashes.default = ShiftDashes;
